// src/app/shared/custom-pagination/custom-pagination.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomPaginationComponent } from './custom-pagination.component';

@NgModule({
  imports: [
    CommonModule,
    MatPaginatorModule,
    CustomPaginationComponent // ✅ standalone component is imported, not declared
  ],
  exports: [CustomPaginationComponent] // ✅ export to use in other modules
})
export class CustomPaginationModule {}
